import React from 'react';

import { GLOBALS } from './globals';

export const ConnectionError = () => (
  <p className="external-accounts-connection-error">
    Cannot connect to external investment accounts. Visit
    <a href={`${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/external-account-center`}>
      {' '}
      Account Center
    </a>{' '}
    to resolve.
  </p>
);

export const UpdateAccountError = () => (
  <p className="external-accounts-update-error">
    Visit{' '}
    <a href={`${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/external-account-center`}>
      Account Center
    </a>{' '}
    to identify the issue.
  </p>
);

export const AuthenticationError = () => (
  <p className="external-accounts-update-error">
    Visit{' '}
    <a href={`${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/external-account-center`}>
      Account Center
    </a>{' '}
    to complete your multi-factor authentication.
  </p>
);

const connectionError = {
  status: 'CONNECTION_ERROR',
  message: <ConnectionError />
};

const lastUpdatedError = {
  status: 'LAST_UPDATED_ERROR_CODE',
  message: <UpdateAccountError />
};

const updateAccountError = {
  status: 'UPDATE_ACCOUNT_ERROR',
  message: <UpdateAccountError />
};

const authenticationError = {
  status: 'AUTHENTICATION_ERROR',
  message: <AuthenticationError />
};

export const externalAccountErrorMap = new Map()
  .set(508, connectionError)
  .set(575, connectionError)
  .set(801, connectionError)
  .set(407, updateAccountError)
  .set(410, updateAccountError)
  .set(401, updateAccountError)
  .set(414, updateAccountError)
  .set(426, updateAccountError)
  .set(412, updateAccountError)
  .set(411, updateAccountError)
  .set(409, updateAccountError)
  .set(406, updateAccountError)
  .set(415, updateAccountError)
  .set(510, updateAccountError)
  .set(909, updateAccountError)
  .set(518, authenticationError)
  .set(509, authenticationError)
  .set(909, lastUpdatedError);
